export default __webpack_public_path__ + "static/media/pat-b&w-pic.d4f0888e.png";